import React, { useContext } from "react";
import { Property } from "src/interfaces/IProperty";
import Select, { Item } from "src/components/UI/Select";
import { makeUseQuery } from "src/services/graphql/utils";
import { queryGetProperties } from "src/services/graphql/Property";
import { Client } from "src/interfaces/IClient";
import { SxProps, Theme } from "@mui/material/styles";
import useAlenProperties from "src/services/alen/useAlenProperties";
import { mergeAlenProperties } from "src/services/alen/utils";
import { Stack, Typography } from "@mui/material";
import AlenLogo from "src/components/AlenLogo";
import WyndPlainLogo from "src/components/WyndPlainLogo";
import { AuthContext } from "src/contexts/AuthContext";

const usePropertyQuery = makeUseQuery(
  queryGetProperties,
  (dbname) => `${dbname}_property`
);

type Props = {
  client: Client;
  propertyName?: string;
  onChange: (property: Property | undefined) => void;
  sx?: SxProps<Theme>;
};
export function Component({ client, propertyName, onChange, sx }: Props) {
  const { data } = usePropertyQuery<Property[]>(client.client_dbname, {
    variables: {},
  });

  const { user } = useContext(AuthContext);

  const alenData = useAlenProperties();
  let mergedData = data;
  if (data && alenData.data) {
    mergedData = mergeAlenProperties(data, alenData.data);
  }

  const handleChange = (value: "" | string) => {
    if (value !== "") {
      const selected = mergedData?.find((p) => p.property_name === value);
      onChange(selected);
    }
  };

  return (
    <Select
      label="Property"
      value={propertyName || ""}
      onChange={handleChange}
      sx={sx}
    >
      {(mergedData || []).map(({ property_id, property_name, alen_id }) => (
        <Item
          key={property_id !== -1 ? property_id : `alen_${alen_id}`}
          value={property_name}
        >
          <Stack direction="row" gap={1} alignItems="center" flex={1}>
            <Typography lineHeight="1rem" flex={1}>
              {property_name}
            </Typography>
            {user?.alen && (
              <>
                {property_id !== -1 && (
                  <WyndPlainLogo sx={{ height: "1rem" }} />
                )}
                {alen_id && <AlenLogo sx={{ height: "1rem" }} />}
              </>
            )}
          </Stack>
        </Item>
      ))}
    </Select>
  );
}

export function Fake({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <Select label="Property" value="" onChange={() => {}} sx={sx}>
      <Item sx={{ display: "none" }} value="" />
    </Select>
  );
}
